<template>
  <div class="baiduQueue">
    <div class="fromClass2">
      <el-form :inline="true" class="demo-form-inline" size="small">
        <el-form-item label="客户姓名">
          <el-input v-model="searchData.name"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="searchData.tel"></el-input>
        </el-form-item>
        <el-form-item label="申请次数">
          <el-input v-model="searchData.loanTimes"></el-input>
        </el-form-item>
        <el-form-item label="放款次数">
          <el-input v-model="searchData.successTimes"></el-input>
        </el-form-item>
        <el-form-item label="跟进次数">
          <el-input v-model="searchData.followUpTimes"></el-input>
        </el-form-item>
        <el-form-item label="意向度">
          <el-select v-model="searchData.intentionLevel" clearable>
            <el-option label="未知" :value="0"></el-option>
            <el-option label="无意向" :value="1"></el-option>
            <el-option label="待进一步了解" :value="2"></el-option>
            <el-option label="考虑中" :value="3"></el-option>
            <el-option label="意向度高" :value="4"></el-option>
            <el-option label="暂时无法处理" :value="7"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="客户来源">
          <el-select v-model="searchData.source" placeholder="请选择客户来源" clearable>
            <el-option :label="item" :value="item" v-for="(item , index) in sourceList" :key="index"></el-option>
          </el-select>
        </el-form-item> -->
        
        <el-form-item label="创建日期">
          <el-date-picker v-model="searchData.startCreateDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
        </el-form-item>
        <el-form-item label="-">
          <el-date-picker v-model="searchData.endCreateDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
        </el-form-item>
        <el-form-item label="销售人员">
          <!-- <el-input v-model="searchData.salesmanId"></el-input> -->
          <el-select v-model="searchData.salesmanId" placeholder="请选择销售人员" clearable>
            <el-option :label="item.name" :value="item.salesmanId" v-for="(item , index) in salesmanUserList2" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录单团队">
          <el-select v-model="searchData.teamId" clearable>
            <el-option :label="item.name" :value="item.teamId" v-for="(item,index) in teamList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最近">
          <el-input v-model="searchData.followTime">
            <template slot="append">天内未跟进</template>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn">
      <div>
        <el-button-group>
          <el-button type="primary" size="small" @click="createUser">添加客户</el-button>
          <el-button type="primary" size="small" @click="add">导入客户</el-button>
          <el-button type="primary" size="small" @click="addUser">指定销售人员</el-button>
          <el-button type="primary" size="small" @click="getGroupData">团队数据详情</el-button>
          <!-- <el-button type="primary" size="small" @click="addUserAll">所有客户指定销售人员</el-button> -->
        </el-button-group>
      </div>
      <div>
        <el-button-group>
          <el-button type="primary" size="small" @click="derive">导出</el-button>
          <el-button type="primary" size="small" @click="refresh">查询</el-button>
        </el-button-group>
      </div>
    </div>
    <div class="tableClass">
      <template>
        <el-table
          ref="multipleTable"
          :data="list.list"
          tooltip-effect="dark"
          style="width: 100%"
          size="small"
          border
          stripe
          :header-cell-style="{ background: '#545c64', color: '#fff' }"
          :row-key="getRowKeys"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              {{scope.row.name}}
            </template>
          </el-table-column>
          <el-table-column label="联系电话">
            <template slot-scope="scope">
              {{scope.row.tel}}
            </template>
          </el-table-column>
          <el-table-column label="意向度">
            <template slot-scope="scope">
              {{scope.row.intentionLevel}}
            </template>
          </el-table-column>
          <!-- <el-table-column label="客户来源">
            <template slot-scope="scope">
              {{scope.row.source}}
            </template>
          </el-table-column> -->
          <el-table-column label="销售人员">
            <template slot-scope="scope">
              {{scope.row.salesman}}
            </template>
          </el-table-column>
          <!-- <el-table-column label="单款单进行中">
            <template slot-scope="scope">
              {{scope.row.canLoan==1?'是':'否'}}
            </template>
          </el-table-column> -->
          <el-table-column label="申请次数">
            <template slot-scope="scope">
              {{scope.row.loanTimes}}
            </template>
          </el-table-column>
          <el-table-column label="放款次数">
            <template slot-scope="scope">
              {{scope.row.successTimes}}
            </template>
          </el-table-column>
          <el-table-column label="跟进次数">
            <template slot-scope="scope">
              {{scope.row.followUpTimes}}
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              {{scope.row.createTime }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="orderCreate(scope.row)"
                  v-if="scope.row.canLoan==1"
                >提交申请单</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="followUp(scope.row)"
                >跟进客户</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="followUpList(scope.row)"
                >跟进记录</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  v-if="scope.row.loanTimes>0"
                  @click="viewOrder(scope.row)"
                >查看申请单</el-button>
                <el-button
                  type="danger"
                  size="mini"
                  v-if="scope.row.loanTimes==0 && (scope.row.intentionLevel=='空号' || scope.row.intentionLevel=='黑名单')"
                  @click="setStatus(scope.row,'删除')"
                >删除客户</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="updateName(scope.row)"
                >编辑姓名</el-button>
                <!-- <el-button
                  type="text"
                  style="cursor: pointer;color:red;"
                  @click="update(scope.row)"
                >删除</el-button> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="1"
          :page-sizes="[10,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.totalRow"
          size="small"
        ></el-pagination>
      </template>
    </div>
    <el-dialog
      title="导入客户"
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="handleClose">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="上传客户文件" prop="name">
          <el-upload
                class="avatar-uploader"
                :action="'https://api.dscj2016.com/api/upload/index'"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                name="file"
                :headers="{'token':token||''}"
                accept=".xls,.xlsx"
              >
              <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="资料来源" prop="source">
          <el-input v-model="form.source"></el-input>
        </el-form-item>
        <el-form-item label="分配销售主管" prop="salesmanLeaderIds">
          <!-- <el-select v-model="form.salesmanLeaderIds"   clearable  >
            <el-option :label="item.name" :value="item.salesmanLeaderId" v-for="(item,index) in salesmanList" :key="index"></el-option>
          </el-select> -->
          <el-checkbox-group v-model="form.salesmanLeaderIds">
            <el-checkbox :label="item.salesmanLeaderId" v-for="(item,index) in salesmanList" :key="index">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="分配销售人员"
      :visible.sync="dialogVisible2"
      width="700px"
      :before-close="handleClose">
      <el-form :model="form2" :rules="rules" ref="ruleForm2" label-width="20px" class="demo-ruleForm">
        <el-form-item label="" prop="salesmanIds">
          <!-- <el-select v-model="form.salesmanLeaderIds"   clearable  >
            <el-option :label="item.name" :value="item.salesmanLeaderId" v-for="(item,index) in salesmanList" :key="index"></el-option>
          </el-select> -->
          <el-checkbox-group v-model="form2.salesmanIds">
            <el-checkbox :label="item.salesmanId" v-for="(item,index) in salesmanUserList" :key="index">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit2">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑姓名"
      :visible.sync="updateNameShow"
      width="700px"
      :before-close="handleClose">
      <el-form :model="updateNameForm" :rules="rules" ref="updateNameForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="客户姓名" prop="name">
          <el-input v-model="updateNameForm.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="updateNameSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="跟进客户"
      :visible.sync="followUpShow"
      width="700px"
      :before-close="handleClose">
      <el-form :model="form3" :rules="rules" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
        <el-form-item label="意向度" prop="intentionLevel">
          <el-select v-model="form3.intentionLevel">
            <el-option label="未知" :value="0"></el-option>
            <el-option label="无意向" :value="1"></el-option>
            <el-option label="待进一步了解" :value="2"></el-option>
            <el-option label="考虑中" :value="3"></el-option>
            <el-option label="意向度高" :value="4"></el-option>
            <el-option label="空号" :value="5"></el-option>
            <el-option label="黑名单" :value="6"></el-option>
            <el-option label="暂时无法处理" :value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form3.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="followUpSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加客户"
      :visible.sync="createUserShow"
      width="700px"
      :before-close="handleClose">
      <el-form :model="form4" :rules="rules2" ref="ruleForm4" label-width="100px" class="demo-ruleForm">
        <el-form-item label="客户姓名" prop="name">
          <el-input v-model="form4.name"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input v-model="form4.tel"></el-input>
        </el-form-item>
        <!-- <el-form-item label="客户来源" prop="source">
          <el-input v-model="form4.source"></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="createUserSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="跟进记录"
      :visible.sync="followUpListShow"
      width="700px"
      :before-close="handleClose">
      <el-table
          ref="multipleTable"
          :data="followUpListData"
          tooltip-effect="dark"
          style="width: 100%"
          size="small"
          border
          stripe
          :header-cell-style="{ background: '#545c64', color: '#fff' }"
        >
          <el-table-column label="跟进人员">
            <template slot-scope="scope">
              {{scope.row.name}}
            </template>
          </el-table-column>
          <el-table-column label="意向度">
            <template slot-scope="scope">
              {{scope.row.intentionLevel}}
            </template>
          </el-table-column>
          <el-table-column label="备注信息">
            <template slot-scope="scope">
              {{scope.row.remark}}
            </template>
          </el-table-column>
          <el-table-column label="跟进时间">
            <template slot-scope="scope">
              {{scope.row.time}}
            </template>
          </el-table-column>
        </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="查看贷款单"
      :visible.sync="orderListShow"
      width="700px"
      :before-close="handleClose">
      <el-table
          ref="multipleTable"
          :data="orderList"
          tooltip-effect="dark"
          style="width: 100%"
          size="small"
          border
          stripe
          :header-cell-style="{ background: '#545c64', color: '#fff' }"
        >
        <el-table-column label="贷款单号">
            <template slot-scope="scope">
              {{scope.row.orderNo}}
            </template>
          </el-table-column>
          <el-table-column label="客户姓名">
            <template slot-scope="scope">
              {{scope.row.name}}
            </template>
          </el-table-column>
          <el-table-column label="联系电话">
            <template slot-scope="scope">
              {{scope.row.tel}}
            </template>
          </el-table-column>
          <el-table-column label="贷款类型">
            <template slot-scope="scope">
              {{scope.row.loanType}}
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              {{scope.row.stateStr}}
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              {{scope.row.createTime }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="viewOrderDetail2(scope.row,true)"
                >查看详情</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  v-if="scope.row.state==8"
                  @click="orderLoanInformationList(scope.row,true)"
                >放款信息</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提交贷款单"
      :visible.sync="orderCreateShow"
      width="700px"
      :before-close="handleClose">
      <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane label="审核信息" name="review" v-if="orderCreateType">
          <el-form :model="orderCreateForm" :rules="orderCreateRules" ref="orderCreateRuleForm" label-width="100px" class="demo-ruleForm" :disabled="orderCreateType">
            <el-form-item label="资方审核进度" prop="reviewProgress" v-if="orderCreateForm.state==5">
              <el-input v-model="orderCreateForm.reviewProgress" ></el-input>
            </el-form-item>
            <el-form-item label="做单人员" prop="doOrderPerson" v-if="orderCreateForm.doOrderPerson">
              <el-input v-model="orderCreateForm.doOrderPerson" ></el-input>
            </el-form-item>
            <el-form-item label="录单人员" prop="salesman" v-if="orderCreateForm.salesman">
              <el-input v-model="orderCreateForm.salesman"></el-input>
            </el-form-item>
            <el-form-item label="批款信息" prop="appropriations_message" v-if="orderCreateForm.appropriations_message">
              <el-input v-model="orderCreateForm.appropriations_message"></el-input>
            </el-form-item>
            <el-form-item label="资方拒绝原因" prop="loan_company_reject_reason" v-if="orderCreateForm.loan_company_reject_reason">
              <el-input v-model="orderCreateForm.loan_company_reject_reason"></el-input>
            </el-form-item>
            <el-form-item label="客户取消原因" prop="customer_give_up_reason" v-if="orderCreateForm.customer_give_up_reason">
              <el-input v-model="orderCreateForm.customer_give_up_reason"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="基础信息" name="user">
          <el-form :model="orderCreateForm" :rules="orderCreateRules" ref="orderCreateRuleForm" label-width="100px" class="demo-ruleForm" :disabled="orderCreateType">
            <el-form-item label="客户姓名" prop="name">
              <el-input v-model="orderCreateForm.name" ></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="tel">
              <el-input v-model="orderCreateForm.tel" ></el-input>
            </el-form-item>
            <el-form-item label="客户来源" prop="origin">
              <el-select v-model="orderCreateForm.origin"   clearable  >
                <el-option label="电销" value="电销"></el-option>
                <el-option label="转介绍" value="转介绍"></el-option>
                <el-option label="老客户" value="老客户"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="贷款类型" prop="loan_type">
              <el-select v-model="orderCreateForm.loan_type"   clearable  >
                <el-option label="房屋抵押" value="房屋抵押"></el-option>
                <el-option label="信用贷款" value="信用贷款"></el-option>
                <el-option label="小微企业贷款" value="小微企业贷款"></el-option>
                <el-option label="汽车贷款" value="汽车贷款"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申请金额" prop="apply_money">
              <el-input v-model="orderCreateForm.apply_money" >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="联系地址" prop="address">
              <el-input v-model="orderCreateForm.address" ></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="id_card">
              <el-input v-model="orderCreateForm.id_card" ></el-input>
            </el-form-item>
            <el-form-item label="婚姻状况" prop="marital_status">
              <el-select v-model="orderCreateForm.marital_status"   clearable  >
                <el-option label="未婚" value="未婚"></el-option>
                <el-option label="已婚" value="已婚"></el-option>
                <el-option label="离异" value="离异"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户类型" prop="customer_type">
              <el-select v-model="orderCreateForm.customer_type"   clearable  >
                <el-option label="上班" value="上班"></el-option>
                <el-option label="做生意" value="做生意"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户的用途" prop="loan_using">
              <el-input v-model="orderCreateForm.loan_using" ></el-input>
            </el-form-item>
            <el-form-item label="家人是否知晓" prop="family_know">
              <el-select v-model="orderCreateForm.family_know"   clearable  >
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户的要求" prop="need">
              <el-input v-model="orderCreateForm.need" ></el-input>
            </el-form-item>
            <el-form-item label="联系人1姓名" prop="contacts1_name">
              <el-input v-model="orderCreateForm.contacts1_name" ></el-input>
            </el-form-item>
            <el-form-item label="联系人1关系" prop="contacts1_relation">
              <el-select v-model="orderCreateForm.contacts1_relation"   clearable  >
                <el-option label="配偶" value="配偶"></el-option>
                <el-option label="亲属" value="亲属"></el-option>
                <el-option label="朋友" value="朋友"></el-option>
                <el-option label="同事" value="同事"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系人1电话" prop="contacts1_tel">
              <el-input v-model="orderCreateForm.contacts1_tel" ></el-input>
            </el-form-item>
            <el-form-item label="联系人2姓名" prop="contacts2_name">
              <el-input v-model="orderCreateForm.contacts2_name" ></el-input>
            </el-form-item>
            <el-form-item label="联系人2关系" prop="contacts2_relation">
              <el-select v-model="orderCreateForm.contacts2_relation"   clearable  >
                <el-option label="配偶" value="配偶"></el-option>
                <el-option label="亲属" value="亲属"></el-option>
                <el-option label="朋友" value="朋友"></el-option>
                <el-option label="同事" value="同事"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系人2电话" prop="contacts2_tel">
              <el-input v-model="orderCreateForm.contacts2_tel" ></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="工作信息" name="job">
          <el-form :model="orderCreateForm" :rules="orderCreateRules" ref="orderCreateRuleForm"  label-width="150px" class="demo-ruleForm" :disabled="orderCreateType">
            <el-form-item label="单位名称" prop="working_name">
              <el-input v-model="orderCreateForm.working_name"></el-input>
            </el-form-item>
            <el-form-item label="单位地址" prop="working_address">
              <el-input v-model="orderCreateForm.working_address"></el-input>
            </el-form-item>
            <el-form-item label="工作年限" prop="working_years">
              <el-input v-model="orderCreateForm.working_years" ></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="job_position">
              <el-select v-model="orderCreateForm.job_position"   clearable  >
                <el-option label="高级管理" value="高级管理"></el-option>
                <el-option label="中层管理" value="中层管理"></el-option>
                <el-option label="普通员工" value="普通员工"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年工资(个税显示为准)" prop="yearly_salary">
              <el-input v-model="orderCreateForm.yearly_salary" ></el-input>
            </el-form-item>
            <el-form-item label="工资发放方式" prop="wage_pay_way">
              <el-select v-model="orderCreateForm.wage_pay_way"   clearable  >
                <el-option label="现金" value="现金"></el-option>
                <el-option label="代发" value="代发"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公积金基数" prop="gongjijin">
              <el-input v-model="orderCreateForm.gongjijin"></el-input>
            </el-form-item>
            <el-form-item label="社保基数" prop="shebao">
              <el-input v-model="orderCreateForm.shebao"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="公司信息" name="company">
          <el-form :model="orderCreateForm" :rules="orderCreateRules" ref="orderCreateRuleForm"  label-width="150px" class="demo-ruleForm" :disabled="orderCreateType">
            <el-form-item label="公司名称" prop="company_name">
              <el-input v-model="orderCreateForm.company_name" ></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="company_job">
              <el-select v-model="orderCreateForm.company_job"   clearable  >
                <el-option label="老板" value="老板"></el-option>
                <el-option label="法人代表" value="法人代表"></el-option>
                <el-option label="股东" value="股东"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公司类型" prop="company_type">
              <el-select v-model="orderCreateForm.company_type"   clearable  >
                <el-option label="个体户" value="个体户"></el-option>
                <el-option label="有限公司" value="有限公司"></el-option>
                <el-option label="个人独资" value="个人独资"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公司经营地址" prop="company_address">
              <el-input v-model="orderCreateForm.company_address" ></el-input>
            </el-form-item>
            <el-form-item label="是否有真实经营场地" prop="company_has_true_address">
              <el-select v-model="orderCreateForm.company_has_true_address"   clearable  >
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否有银联收款码" prop="company_has_payment_code">
              <el-select v-model="orderCreateForm.company_has_payment_code"   clearable  >
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="经营场地" prop="company_address_nature">
              <el-select v-model="orderCreateForm.company_address_nature"   clearable  >
                <el-option label="租用" value="租用"></el-option>
                <el-option label="自有财产" value="自有财产"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年营业额" prop="company_month_income">
              <el-input v-model="orderCreateForm.company_month_income" ></el-input>
            </el-form-item>
            <el-form-item label="是否有开票纳税" prop="company_has_pay_taxes">
              <el-select v-model="orderCreateForm.company_has_pay_taxes"   clearable  >
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="纳税等级" prop="company_pay_taxes_level">
              <el-select v-model="orderCreateForm.company_pay_taxes_level"   clearable  >
                <el-option label="A级" value="A"></el-option>
                <el-option label="B级" value="B"></el-option>
                <el-option label="M级" value="M"></el-option>
                <el-option label="C级" value="C"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="近1年开票金额" prop="company_year_invoice_money">
              <el-input v-model="orderCreateForm.company_year_invoice_money" ></el-input>
            </el-form-item>
            <el-form-item label="近1年纳税金额" prop="company_year_taxes_money">
              <el-input v-model="orderCreateForm.company_year_taxes_money" ></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="房产信息" name="house">
          <el-form :model="orderCreateForm" :rules="orderCreateRules" ref="orderCreateRuleForm" label-width="100px" class="demo-ruleForm" :disabled="orderCreateType">
            <el-form-item label="房产类型" prop="house_type">
              <el-select v-model="orderCreateForm.house_type"   clearable  >
                <el-option label="住宅" value="住宅"></el-option>
                <el-option label="公寓" value="公寓"></el-option>
                <el-option label="办公" value="办公"></el-option>
                <el-option label="商铺" value="商铺"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="房产性质" prop="house_nature">
              <el-select v-model="orderCreateForm.house_nature"   clearable  >
                <el-option label="全款" value="全款"></el-option>
                <el-option label="按揭" value="按揭"></el-option>
                <el-option label="抵押" value="抵押"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="房产所有权" prop="house_ownership">
              <el-select v-model="orderCreateForm.house_ownership"   clearable  >
                <el-option label="个人所有" value="个人所有"></el-option>
                <el-option label="夫妻共有" value="夫妻共有"></el-option>
                <el-option label="家人共有" value="家人共有"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="房产地址" prop="house_address">
              <el-input v-model="orderCreateForm.house_address" ></el-input>
            </el-form-item>
            <el-form-item label="楼盘名称" prop="lpmc">
              <el-input v-model="orderCreateForm.lpmc" ></el-input>
            </el-form-item>
            <el-form-item label="建筑面积" prop="house_area">
              <el-input v-model="orderCreateForm.house_area" ></el-input>
            </el-form-item>
            <el-form-item label="建筑年份" prop="house_year_built">
              <el-input v-model="orderCreateForm.house_year_built" ></el-input>
            </el-form-item>
            <el-form-item label="抵押银行" prop="house_mortgage_to_bank" v-if="orderCreateForm.house_nature!='全款'">
              <el-input v-model="orderCreateForm.house_mortgage_to_bank" ></el-input>
            </el-form-item>
            <el-form-item label="抵押金额" prop="house_mortgage_money" v-if="orderCreateForm.house_nature!='全款'">
              <el-input v-model="orderCreateForm.house_mortgage_money" ></el-input>
            </el-form-item>
            <el-form-item label="抵押期限" prop="house_mortgage_long" v-if="orderCreateForm.house_nature!='全款'">
              <el-input v-model="orderCreateForm.house_mortgage_long" ></el-input>
            </el-form-item>
            <!-- <el-form-item label="每月还款" prop="house_month_return_money" v-if="orderCreateForm.house_nature=='按揭'">
              <el-input v-model="orderCreateForm.house_month_return_money" ></el-input>
            </el-form-item> -->
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="车辆信息" name="car">
          <el-form :model="orderCreateForm" :rules="orderCreateRules" ref="orderCreateRuleForm" label-width="100px" class="demo-ruleForm" :disabled="orderCreateType">
            <el-form-item label="汽车品牌" prop="car_brand">
              <el-input v-model="orderCreateForm.car_brand" ></el-input>
            </el-form-item>
            
            <el-form-item label="车辆所有人" prop="car_ownership">
              <el-select v-model="orderCreateForm.car_ownership"   clearable  >
                <el-option label="本人" value="本人"></el-option>
                <el-option label="家人" value="家人"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="汽车性质" prop="car_nature">
              <el-select v-model="orderCreateForm.car_nature"   clearable  >
                <el-option label="全款" value="全款"></el-option>
                <el-option label="按揭" value="按揭"></el-option>
                <el-option label="抵押" value="抵押"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="行驶公里数" prop="car_ran_kilometers">
              <el-input v-model="orderCreateForm.car_ran_kilometers" >
                <template slot="append">万公里</template>
              </el-input>
            </el-form-item>
            <el-form-item label="购买时间" prop="car_buy_time">
              <el-date-picker v-model="orderCreateForm.car_buy_time" type="month" value-format="yyyy-MM" format="yyyy-MM" placeholder=" "> </el-date-picker>
              <!-- <el-input v-model="orderCreateForm.car_buy_time" ></el-input> -->
            </el-form-item>
            <el-form-item label="寿险保单" prop="car_has_commercial_insurance">
              <el-select v-model="orderCreateForm.car_has_commercial_insurance"   clearable  >
                <el-option label="有" value="有"></el-option>
                <el-option label="无" value="无"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="投保时间" prop="car_policy_holder" v-if="orderCreateForm.car_has_commercial_insurance=='有'">
              <el-date-picker v-model="orderCreateForm.car_policy_holder" type="month" value-format="yyyy-MM" format="yyyy-MM" placeholder=" "> </el-date-picker>
            </el-form-item>
            <el-form-item label="每年投保金额" prop="car_policy_company" v-if="orderCreateForm.car_has_commercial_insurance=='有'">
              <el-input v-model="orderCreateForm.car_policy_company" >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="征信信息" name="number">
          <el-form :model="orderCreateForm" :rules="orderCreateRules" ref="orderCreateRuleForm" label-width="120px" class="demo-ruleForm" :disabled="orderCreateType">
            <el-form-item label="贷款笔数" prop="number_of_liabilities">
              <el-input v-model="orderCreateForm.number_of_liabilities" ></el-input>
            </el-form-item>
            <el-form-item label="贷款授信总额" prop="total_liabilities">
              <el-input v-model="orderCreateForm.total_liabilities" ></el-input>
            </el-form-item>
            <el-form-item label="余额" prop="sxye">
              <el-input v-model="orderCreateForm.sxye" ></el-input>
            </el-form-item>
            <el-form-item label="近半年平均还款额" prop="bnpjhke">
              <el-input v-model="orderCreateForm.bnpjhke" ></el-input>
            </el-form-item>
            <el-form-item label="信用卡机构数" prop="bankcard_num">
              <el-input v-model="orderCreateForm.bankcard_num" ></el-input>
            </el-form-item>
            <el-form-item label="信用卡授信总额" prop="total_bankcard_money">
              <el-input v-model="orderCreateForm.total_bankcard_money" ></el-input>
            </el-form-item>
            <el-form-item label="已用额度" prop="bankcard_overdraw_money">
              <el-input v-model="orderCreateForm.bankcard_overdraw_money" ></el-input>
            </el-form-item>
            <el-form-item label="近半年平均使用额" prop="month_return_money">
              <el-input v-model="orderCreateForm.month_return_money" ></el-input>
            </el-form-item>
            <el-form-item label="征信最近3个月查询次数" prop="credit_check_times">
              <el-input v-model="orderCreateForm.credit_check_times" ></el-input>
            </el-form-item>

          </el-form>
        </el-tab-pane>
        <el-tab-pane label="附件信息" name="file">
          <el-form :model="orderCreateForm" :rules="orderCreateRules" ref="orderCreateRuleForm" label-width="100px" class="demo-ruleForm" :disabled="orderCreateType">
            <el-form-item label="文件">
                <el-upload
                  class="avatar-uploader"
                  :action="'https://api.dscj2016.com/api/upload/index'"
                  :show-file-list="false"
                  :on-success="orderCreateFileSuccess"
                  :before-upload="orderCreateFileUpload"
                  name="file"
                  multiple
                  :headers="{'token':token||''}"
                    
                >
                <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            </el-form-item>
            <el-form-item v-if="orderCreateForm.files.length">
              <el-tag
                v-for="(item,index) in orderCreateForm.files"
                :key="item"
                :closable="!orderCreateType"
                type="success"
                @close="deleteFile(index)"
                @click="xiazai(index)"
                style="cursor: pointer;">
                {{item}}
              </el-tag>
            </el-form-item>
            
            <el-form-item label="图片">
              <el-upload
                    class="avatar-uploader"
                    :action="'https://api.dscj2016.com/api/upload/index'"
                    :show-file-list="false"
                    :on-success="orderCreateImageSuccess"
                    :before-upload="orderCreateImageUpload"
                    name="file"
                    multiple
                    :headers="{'token':token||''}"
                    accept="image/jpg,image/jpeg,image/png"
                  >
                  <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="orderCreateForm.images.length">
              <div style="display: flex;">
                <div style="margin-right:10px;margin-bottom:10px;position:relative;" v-for="(item,index) in orderCreateForm.images" :key="index">
                  <el-image 
                    style="width: 100px; height: 100px;"
                    :src="item" 
                    :preview-src-list="orderCreateForm.images"
                    >
                  </el-image>
                  <img v-if="!orderCreateType" @click="deleteImg(index)" style="position:absolute;top: -10px;right: -10px;width: 20px;height: 20px;cursor: pointer;" src="/static/close2.png" />
                </div>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="备注信息" name="qita">
          <el-form :model="orderCreateForm" :rules="orderCreateRules" ref="orderCreateRuleForm" label-width="100px" class="demo-ruleForm" :disabled="orderCreateType">
            <el-form-item label="备注">
              <el-input type="textarea" v-model="orderCreateForm.remark" ></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" v-if="!orderCreateType">取 消</el-button>
        <el-button @click="closeViewOrder" v-if="orderCreateType">关闭</el-button>
        <el-button type="success" @click="orderCreateSubmit(false)" v-if="!orderCreateType">保 存</el-button>
        <el-button type="success" @click="orderCreateSubmit(true)" v-if="!orderCreateType">提 交</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="查看放款信息"
      :visible.sync="loanInformationListShow"
      width="700px"
      :before-close="handleClose">
      <el-table
          ref="multipleTable"
          :data="loanInformationList"
          tooltip-effect="dark"
          style="width: 100%"
          size="small"
          border
          stripe
          :header-cell-style="{ background: '#545c64', color: '#fff' }"
        >
        <el-table-column label="贷款单号">
            <template slot-scope="scope">
              {{scope.row.orderNo}}
            </template>
          </el-table-column>
          <el-table-column label="贷款类型">
            <template slot-scope="scope">
              {{scope.row.loan_type}}
            </template>
          </el-table-column>
          <el-table-column label="贷后管理人员">
            <template slot-scope="scope">
              {{scope.row.manager}}
            </template>
          </el-table-column>
          <el-table-column label="贷款金额">
            <template slot-scope="scope">
              {{scope.row.money}}
            </template>
          </el-table-column>
          <el-table-column label="放款时间">
            <template slot-scope="scope">
              {{scope.row.get_day}}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="viewOrderDetail(scope.row,true)"
                >查看详情</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="viewDetailType?'查看详情':`编辑放款信息`"
      :visible.sync="viewDetailShow"
      width="700px"
      :before-close="handleClose">
      <el-form :model="detail" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm"  :disabled="viewDetailType">
        <el-form-item label="录入人员">
            <el-input v-model="detail.createAdmin" ></el-input>
          </el-form-item>
          <el-form-item label="录入时间">
            <el-input v-model="detail.create_time" ></el-input>
          </el-form-item>
          <el-form-item label="贷后管理人员">
            <el-input v-model="detail.managerAdmin" ></el-input>
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input v-model="detail.customer_name" ></el-input>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="detail.customer_tel" ></el-input>
          </el-form-item>
          
          <el-form-item label="贷款类型">
            <el-select v-model="detail.loan_type"   clearable  >
              <el-option label="房屋抵押" value="房屋抵押"></el-option>
                <el-option label="信用贷款" value="信用贷款"></el-option>
                <el-option label="小微企业贷款" value="小微企业贷款"></el-option>
                <el-option label="汽车贷款" value="汽车贷款"></el-option>
                <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="放款机构">
            <el-input v-model="detail.loan_company" ></el-input>
          </el-form-item>
          <el-form-item label="贷款金额">
            <el-input v-model="detail.money" ></el-input>
          </el-form-item>
          <el-form-item label="贷款期限">
            <el-input v-model="detail.how_long" ></el-input>
          </el-form-item>
          <el-form-item label="年利率">
            <el-input v-model="detail.year_interest" ></el-input>
          </el-form-item>
          <el-form-item label="月利率">
            <el-input v-model="detail.month_interest" ></el-input>
          </el-form-item>
          <el-form-item label="还款方式">
            <el-select v-model="detail.repayment_type"   clearable  >
              <el-option label="等额本息" value="等额本息"></el-option>
              <el-option label="先息后本" value="先息后本"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" v-if="detail.repayment_type=='其他'">
            <el-input v-model="detail.remark" ></el-input>
          </el-form-item>
          <el-form-item label="放款日期">
            <el-date-picker v-model="detail.get_day" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
          </el-form-item>
          <el-form-item label="还款日">
            <el-select v-model="detail.repayment_day"   clearable  >
              <el-option :label="item+'日'" :value="item+'日'" v-for="(item,index) in 31" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="到期日期">
            <el-date-picker v-model="detail.due_date" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" v-if="!viewDetailType">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 团队数据弹窗 -->
    <el-dialog
      title="团队详情"
      :visible.sync="showGroupData"
      width="700px"
      @close="closeGroupDialog">
      <div class="groupTable">
        <div class="datePicker">
          <div class="text">日期选择：</div>
           <el-date-picker
            v-model="groupTime"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="timeChange">
           </el-date-picker>
        </div>
         <el-table
          ref="multipleTable"
          :data="groupData"
          tooltip-effect="dark"
          style="width: 100%"
          size="small"
          border
          stripe
          :header-cell-style="{ background: '#545c64', color: '#fff' }"
          :row-key="getRowKeys"
          @selection-change="handleSelectionChange"
        >
          <el-table-column label="团队名称" >
            <template slot-scope="scope">
              {{scope.row.name}}
            </template>
          </el-table-column>
          <el-table-column label="新增客户人数">
            <template slot-scope="scope">
              {{scope.row.create_num}}
            </template>
          </el-table-column>
          <el-table-column label="跟进客户人数">
            <template slot-scope="scope">
              {{scope.row.follow_num}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { groupData } from "echarts/lib/util/model";
import Cookie from "js-cookie";

export default {
  title: "课程列表",
  data() {
    return {
      groupTime: [],
      startTime: '',
      endTime: '',
      groupData: [], //团队数据
      showGroupData: false,  // 显示团队数据
      teamList:[],// 录单团队列表
      activeName:"user",
      sourceList:[],
      salesmanList:[],
      salesmanUserList:[],
      salesmanUserList2:[],
      token:'',
      page: 1,
      pageSize:10,
      list:{
      },
      searchData:{
        name:'',
        tel:'',
        intentionLevel:'',
        loanTimes:'0',
        successTimes:'',
        followUpTimes:'',
        source:'',
        endCreateDate:'',
        startCreateDate:'',
        salesmanId:'',
        teamId: '',
        followTime: ''
      },
      parentList:[],
      dialogVisible:false,
      dialogVisible2:false,
      followUpShow:false,
      createUserShow:false,
      followUpListShow:false,
      followUpListData:[],
      form:{
        salesmanLeaderIds:[],
        source:'',
        file:''
      },
      form2:{
        customerIds:[],
        salesmanIds:[],
        type:1
      },
      form3:{
        customerId:'',
        intentionLevel:'',
        remark:''
      },
      form4:{
        name:'',
        tel:'',
        source:'无'
      },
      rules:{
        source: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        file: [
          { required: true, message: '请上传客户文件', trigger: 'change' }
        ],
        salesmanLeaderIds: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        salesmanIds: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        intentionLevel: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
      },
      rules2:{
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        // source: [
        //   { required: true, message: '请选择', trigger: 'change' }
        // ],
      },
      // 提交贷款单————————————————————————————————————————————————————————————
      orderCreateShow:false,
      orderCreateType:false,
      orderCreateForm:{
        customer_id:'',
        origin:'',
        loan_type:'',
        name:'',
        id_card:'',
        birthday:'',
        gender:'',
        tel:'',
        address:'',
        marital_status:'',
        customer_type:'',
        apply_money:'',
        loan_using:'',
        family_know:'',
        need:'',
        contacts1_name:'',
        contacts1_relation:'',
        contacts1_tel:'',
        contacts2_name:'',
        contacts2_relation:'',
        contacts2_tel:'',
        working_years:'',
        job_position:'',
        yearly_salary:'',
        wage_pay_way:'',
        gongjijin:'',
        shebao:'',
        house_type:'',
        house_nature:'',
        house_ownership:'',
        house_address:'',
        lpmc:'',
        house_area:'',
        house_year_built:'',
        house_mortgage_to_bank:'',
        house_mortgage_money:'',
        house_mortgage_long:'',
        house_month_return_money:'',
        car_brand:'',
        car_ownership:'',
        car_nature:'',
        car_ran_kilometers:'',
        car_has_commercial_insurance:'',
        car_policy_holder:'',
        car_policy_company:'',
        car_buy_time:'',
        number_of_liabilities:'',
        sxye:'',
        bnpjhke:'',
        total_liabilities:'',
        month_return_money:'',
        bankcard_num:'',
        total_bankcard_money:'',
        bankcard_overdraw_money:'',
        credit_check_times:'',
        company_name:'',
        company_job:'',
        company_type:'',
        company_address:'',
        company_has_true_address:'',
        company_has_payment_code:'',
        company_address_nature:'',
        company_month_income:'',
        company_has_pay_taxes:'',
        company_pay_taxes_level:'',
        company_year_invoice_money:'',
        company_year_taxes_money:'',
        files:[],
        images:[],
        remark:''
      },
      orderCreateRules:{},
      orderListShow:false,
      orderList:[],
      loanInformationListShow:false,
      loanInformationList:[],
      viewDetailShow:false,
      viewDetailType:false,
      viewDetailAddShow:false,
      detail:{},
      updateNameShow:false,
      updateNameForm:{
        customerId:'',
        name:''
      }
    };
  },
  computed: {
  },
  components: {},
  filters: {
    date1(e) {
      let date = new Date(e);
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds()
      );
    }
  },
  methods: {
    closeGroupDialog() {
      this.showGroupData = false; // 关闭团队数据弹窗
      this.groupTime = []; // 清空日期选择器
      this.startTime = undefined
      this.endTime = undefined
    },
    // 团队日期发生改变
    timeChange(val) {
      console.log('val',val)
      this.startTime = val[0];
      this.endTime = val[1];
      this.getGroupData();
    },
    
    // 获取团队数据
    getGroupData() {
      if(!this.startTime || !this.endTime) {
        const now = new Date(); // 获取当前时间
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需+1
        const day = String(now.getDate()).padStart(2, '0');
        this.endTime = `${year}-${month}-${day}`;
        this.startTime = `${year}-${month}-${day}`;
        this.groupTime = [this.startTime, this.endTime]; // 设置默认值为当前日期
      }
      this.$axios.post('/api/customer/createAndFollow',this.$qs.stringify({startTime:this.startTime,endTime:this.endTime})).then(res=>{
        if(res && res.data && res.data.code == 1){
          this.groupData = res.data.data; 
          this.showGroupData = true; // 显示团队数据
        } else {
          this.$message.warning('您没有权限查看团队数据!');
        }
      }).catch(err => {
        console.log('err',err)
      })
    },
    updateName(e){
      this.updateNameShow=true
      this.updateNameForm={
        customerId:e.id,
        name:e.name
      }
    },
    updateNameSubmit(){
      this.$refs['updateNameForm'].validate((valid) => {
        if (valid) {
          this.$axios.post('/api/customer/updateName',this.$qs.stringify(this.updateNameForm)).then(res=>{
              if (res.data.code == 1) {
                this.$message({
                  message: `编辑成功`,
                  type: "success",
                });
                this.getData()
                this.handleClose()
              }else{
                this.$message.error(res.data.msg);
              }
          })
          
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    setStatus(e,index){
      this.$confirm(`确定${index}该员工吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            customerId:e.id,
          };
          if(index=='删除'){
            this.$axios.post('/api/customer/del',this.$qs.stringify(params)).then(res=>{
                if (res.data.code == 1) {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.getData()
                }else{
                  this.$message.error(res.data.msg);
                }
            })
          }
          
        })
        .catch(() => {});
    },
    // 查看放款信息————————————————————————————————————————————————————————————————————-——
    orderLoanInformationList(e){
      this.$axios.post('/api/loan_order/getLoanInformationList',this.$qs.stringify({id:e.id})).then(res=>{
          if (res.data.code == 1) {
            this.loanInformationList=res.data.data
            this.loanInformationListShow=true
          }
      })
    },
    viewOrderDetail(e,index){
      console.log(e)
      this.$axios.post('/api/loan_information/getInfo',this.$qs.stringify({id:e.informationId})).then(res=>{
          if (res.data.code == 1) {
            this.detail=res.data.data
            this.viewDetailShow=true
            this.viewDetailType=index
          }
      })
    },
    // 查看贷款单——————————————————————————————————————————————
    viewOrder(e){
      this.$axios.post('/api/customer/getLoanOrderList',this.$qs.stringify({customerId:e.id})).then(res=>{
          if (res.data.code == 1) {
            this.orderList=res.data.data
            this.orderListShow=true
          }
      })
    },
    viewOrderDetail2(e,index){
      this.$axios.post('/api/customer/loanOrderInfo',this.$qs.stringify({id:e.id})).then(res=>{
          if (res.data.code == 1) {
            let order = res.data.data
            order.images=JSON.parse(res.data.data.images)
            order.files=JSON.parse(res.data.data.files)
            this.orderCreateForm=order
            this.orderCreateShow=true
            this.orderCreateType=index
            this.activeName=index?'review':'user'
          }
      })
    },
    closeViewOrder(){
      this.setData()
      this.orderCreateShow=false
      this.orderCreateType=false
      this.orderListShow=true
      this.activeName='user'
    },
    // 添加客户————————————————————————————————————————
    createUser(){
      this.createUserShow=true
      this.setData()
    },
    createUserSubmit(){
      this.$refs['ruleForm4'].validate((valid) => {
        if (valid) {
          this.$axios.post('/api/customer/add',this.$qs.stringify(this.form4)).then(res=>{
              if (res.data.code == 1) {
                this.$message({
                  message: `添加成功`,
                  type: "success",
                });
                this.getData()
                this.handleClose()
              }else{
                this.$message.error(res.data.msg);
              }
          })
          
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 跟进客户——————————————————————————————————————————————
    followUp(e){
      this.form3.customerId=e.id
      this.followUpShow=true
    },
    followUpList(e){
      this.$axios.post('/api/customer/followUpRecord',this.$qs.stringify({customerId:e.id})).then(res=>{
          if (res.data.code == 1) {
            console.log(res)
            this.followUpListData=res.data.data
            this.followUpListShow=true
          }
      })
      
    },
    followUpSubmit(){
      this.$refs['ruleForm3'].validate((valid) => {
        if (valid) {
          this.$axios.post('/api/customer/followUp',this.$qs.stringify(this.form3)).then(res=>{
              if (res.data.code == 1) {
                this.$message({
                  message: `跟进成功`,
                  type: "success",
                });
                this.getData()
                this.handleClose()
              }else{
                this.$message.error(res.data.msg);
              }
          })
          
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 
    orderCreate(e){
      this.$axios.post('/api/loan_order/getTemp',this.$qs.stringify({customer_id:e.id})).then(res=>{
          if (res.data.code == 1) {
            this.orderCreateShow=true
            this.orderCreateType=false
            this.activeName='user'
            this.orderCreateForm.customer_id=e.id
            if(res.data.data.name){
              this.orderCreateForm=res.data.data
              this.orderCreateForm.files=JSON.parse(res.data.data.files)
              this.orderCreateForm.images=JSON.parse(res.data.data.images)
            }else{
              this.orderCreateForm.name=e.name
            }
            
            
          }else{
            this.$message.error(res.data.msg);
          }
      })
      
    },
    orderCreateSubmit(type){
      let form = {...this.orderCreateForm}
      form.files=JSON.stringify(form.files)
      form.images=JSON.stringify(form.images)
      if(type){
        this.$axios.post('/api/loan_order/create',this.$qs.stringify(form)).then(res=>{
            if (res.data.code == 1) {
              this.$message({
                message: `操作成功`,
                type: "success",
              });
              this.getData()
              this.handleClose()
            }else{
              this.$message.error(res.data.msg);
            }
        })
      }else{
        this.$axios.post('/api/loan_order/saveTemp',this.$qs.stringify(form)).then(res=>{
          if (res.data.code == 1) {
            this.$message({
              message: `操作成功`,
              type: "success",
            });
            this.getData()
            this.handleClose()
          }else{
            this.$message.error(res.data.msg);
          }
      })
      }
      
    },
    orderCreateFileSuccess(res,file){
      if(res.code==1){
        this.orderCreateForm.files.push(res.data)
      }else{
        this.$message({
          message: res.errorMsg,
          type: "danger",
        });
      }
    },
    orderCreateFileUpload(res){
    },
    orderCreateImageSuccess(res,file){
      this.orderCreateForm.images.push(res.data)
    },
    orderCreateImageUpload(){

    },
    deleteImg(e){
      this.orderCreateForm.images.splice(e,1)
    },
    deleteFile(e){
      this.orderCreateForm.files.splice(e,1)
    },
    xiazai(e){
      const a = document.createElement('a'); // 创建一个HTML 元素
      let url = this.orderCreateForm.files[e];
      a.setAttribute('download', ''); //download属性
      a.setAttribute('href', url); // href链接
      a.click();
    },
    // 批量指定销售人员
    addUser(){
      if(!this.form2.customerIds.length){
        this.$message({
          message: `请选择客户`,
          type: "warning",
        });
        return
      }
      this.form2.type=1
      this.dialogVisible2=true
      this.$axios.post('/api/customer/salesmanList').then(res=>{
          this.salesmanUserList=res.data.data
      })
    },
    // addUserAll(){
    //   this.dialogVisible2=true
    //   this.form2.type=2
    //   this.$axios.post('/api/customer/salesmanList').then(res=>{
    //       this.salesmanUserList=res.data.data
    //   })
    // },
    submit2(){
      this.$refs['ruleForm2'].validate((valid) => {
        if (valid) {
          this.form2.customerIds=this.form2.type==2?'all':JSON.stringify(this.form2.customerIds)
          this.form2.salesmanIds=JSON.stringify(this.form2.salesmanIds)
          this.$axios.post('/api/customer/divide',this.$qs.stringify(this.form2)).then(res=>{
              if (res.data.code == 1) {
                this.$message({
                  message: `分配成功`,
                  type: "success",
                });
                this.getData()
                this.handleClose()
              }else{
                this.$message.error(res.data.msg);
              }
          })
          
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 导入客户——————————————————————————————————————————————————
    add(){
      this.setData()
      this.$axios.post('/api/customer/salesmanLeaderList',).then(res=>{
            this.salesmanList=res.data.data
            this.dialogVisible=true
      })
      
    },
    handleClose(){
      this.setData()
      this.updateNameShow=false
      this.dialogVisible=false
      this.dialogVisible2=false
      this.orderCreateShow=false
      this.followUpShow=false
      this.followUpListShow=false
      this.createUserShow=false
      this.orderListShow=false
      this.viewDetailShow=false
      // this.orderCreateType=false
      this.loanInformationListShow=false
    },  
    setData(){
      this.followUpListData=[]
      this.form={
        salesmanLeaderIds:[],
        source:'',
        file:''
      }
      this.form2={
        customerIds:[],
        salesmanIds:[]
      }
      this.$refs.multipleTable.clearSelection();
      this.form3={
        customerId:'',
        intentionLevel:'',
        remark:''
      }
      this.form4={
        name:'',
        tel:'',
        source:'无'
      }
      this.orderCreateForm={
        origin:'',
        loan_type:'',
        name:'',
        id_card:'',
        birthday:'',
        gender:'',
        tel:'',
        address:'',
        marital_status:'',
        apply_money:'',
        customer_type:'',
        loan_using:'',
        family_know:'',
        need:'',
        contacts1_name:'',
        contacts1_relation:'',
        contacts1_tel:'',
        contacts2_name:'',
        contacts2_relation:'',
        contacts2_tel:'',
        working_years:'',
        job_position:'',
        yearly_salary:'',
        wage_pay_way:'',
        gongjijin:'',
        shebao:'',
        house_type:'',
        house_nature:'',
        house_ownership:'',
        house_address:'',
        lpmc:'',
        house_area:'',
        house_year_built:'',
        house_mortgage_to_bank:'',
        house_mortgage_money:'',
        house_mortgage_long:'',
        house_month_return_money:'',
        car_brand:'',
        car_ownership:'',
        car_nature:'',
        car_ran_kilometers:'',
        car_has_commercial_insurance:'',
        car_policy_holder:'',
        car_policy_company:'',
        car_buy_time:'',
        number_of_liabilities:'',
        sxye:'',
        bnpjhke:'',
        total_liabilities:'',
        month_return_money:'',
        bankcard_num:'',
        total_bankcard_money:'',
        bankcard_overdraw_money:'',
        credit_check_times:'',
        company_name:'',
        company_job:'',
        company_type:'',
        company_address:'',
        company_has_true_address:'',
        company_has_payment_code:'',
        company_address_nature:'',
        company_month_income:'',
        company_has_pay_taxes:'',
        company_pay_taxes_level:'',
        company_year_invoice_money:'',
        company_year_taxes_money:'',
        files:[],
        images:[],
        remark:''
      }
    },
    beforeAvatarUpload(file) {
    },
    handleAvatarSuccess(res, file) {
      this.form.file=res.data
    },
    submit(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.form.salesmanLeaderIds=JSON.stringify(this.form.salesmanLeaderIds)
          this.$axios.post('/api/customer/import',this.$qs.stringify(this.form)).then(res=>{
              if (res.data.code == 1) {
                this.$message({
                  message: `共导入${res.data.data.totalNum}条数据，成功${res.data.data.successNum}条数据，失败${res.data.data.failNum}条数据`,
                  type: "success",
                });
                this.getData()
                this.handleClose()
              }else{
                this.$message.error(res.data.msg);
              }
          })
          
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    roleTypeChange(e){
      const arr = [3, 6, 8];
      if(!arr.includes(e)){
        return
      }
      let params = {
        roleType:e
      };
      this.$axios.post('/api/admin/getParent',this.$qs.stringify(params)).then(res=>{
          this.parentList=res.data.data
      })
    },
    // 查询列表————————————————————————————————————————————————————————
    derive(){
      let params = {
        page:this.page,
        pageSize:this.pageSize,
        name:this.searchData.name,
        tel:this.searchData.tel,
        intentionLevel:this.searchData.intentionLevel,
        loanTimes:this.searchData.loanTimes || '-1',
        successTimes:this.searchData.successTimes || '-1',
        followUpTimes:this.searchData.followUpTimes || '-1',
        source:this.searchData.source,
        isExport:1,
        startCreateDate:this.searchData.startCreateDate||'',
        endCreateDate:this.searchData.endCreateDate||'',
        teamId: this.searchData.teamId||'',
        followTime: this.searchData.followTime
      };
      this.$axios.post('/api/customer/getList',this.$qs.stringify(params)).then(res=>{
        if (res.data.code == 1){
          const a = document.createElement('a'); // 创建一个HTML 元素
          let url = res.data.data;
          a.setAttribute('download', ''); //download属性
          a.setAttribute('href', url); // href链接
          a.click();
        }else{
          this.$message.error(res.data.msg);
        }
        
      })
    },
    getRowKeys(row) {
      return row.id;
    },
    handleSelectionChange(e) {
      console.log(e)
      this.form2.customerIds=[]
      for (let i = 0; i < e.length; i++) {
        this.form2.customerIds.push(e[i].id);
      }
    },
    handleCurrentChange(e) {
      this.page = e;
      this.getData();
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.getData();
    },
    refresh() {
      this.page = 1;
      this.getData();
    },
    getData() {
      let params = {
        page:this.page,
        pageSize:this.pageSize,
        name:this.searchData.name,
        tel:this.searchData.tel,
        intentionLevel:this.searchData.intentionLevel,
        loanTimes:this.searchData.loanTimes || '-1',
        successTimes:this.searchData.successTimes || '-1',
        followUpTimes:this.searchData.followUpTimes || '-1',
        source:this.searchData.source,
        startCreateDate:this.searchData.startCreateDate||'',
        endCreateDate:this.searchData.endCreateDate||'',
        salesmanId:this.searchData.salesmanId||'',
        teamId: this.searchData.teamId||'',
        followTime: this.searchData.followTime
      };
      this.$axios.post('/api/customer/getList',this.$qs.stringify(params)).then(res=>{
          this.list=res.data.data
      })
      
    }
  },

  mounted() {
    this.getData();
    this.$axios.post('/api/customer/getCanSelectSource',).then(res=>{
          this.sourceList=res.data.data
    })
    this.$axios.post('/api/customer/salesmanList').then(res=>{
          this.salesmanUserList2=res.data.data
      })
      this.$axios.post('/api/admin/saleTeams').then(res=>{
          this.teamList=res.data.data
      })
    this.token=Cookie.get("token")
  }
};
</script>  
<style lang="scss" scoped>
.el-button--mini{
  margin-top: 10px;
  margin-left: 0 !important;
}
.el-select{
  width: 100% !important;
}
.flex{
  display: flex;
  align-items: center;
  img{
    width: 100px;
    height: 100px;
    margin-right: 50px;
  }
  
}
.baiduQueue {
  width: calc(100% - 40px);
  padding: 20px 0;
  min-height: 680px;
  .userNumber {
    width: 90%;
    height: 30px;
    margin: 0 auto;
    text-align: left;
    overflow: hidden;
    & > div {
      font-size: 12px;
      color: gray;
      margin-top: 10px;
      span {
        font-weight: 600;
        cursor: pointer;
      }
    }
  }
  .fromClass2 {
    width: 90%;
    height: auto;
    margin: 10px auto;
    padding: 10px 0;
    display: flex;

    align-content: center;
  }
  .tableClass {
    width: 90%;
    margin: 0 auto;
  }
  //   .el-dialog__body{
  //       padding: 10px 20px;
  //       display: flex;
  //       justify-content: center;
  //       align-items: center;
  //   }
}
.btn {
  width: 90%;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
}
.initializeTitle {
  font-size: 14px;
  color: gray;
}
.el-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.el-dialog__body {
  padding: 20px;
}
.hidden {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  height: 23px !important;
}
.tableImg {
  width: 34px;
  height: 34px;
}
.groupTable {
  max-height: 800px;
  overflow-y: auto;
  .datePicker {
    padding: 0 80px;
  .text {
    flex-shrink: 0;
    margin-right: 20px;

  }
   display: flex;
   align-items: center;
   margin-bottom: 20px;
  }
}
</style>  


// WEBPACK FOOTER //
// src/pages/customer/index.vue